<div class="skeleton-container" 
    [ngClass]="skeletonSize" 
    *ngIf="skeletonType === 'text'"
    [class.padding]="skeletonStyle === 'padding'"
    [class.no-padding]="skeletonStyle === 'none'"
    >
    <div class="skeleton-body">
        <h3 class="skeleton-body-title" *ngIf="skeletonTitle">
            <span class="skeleton-row" style="width:55%;"></span>
        </h3>
        <div>
            <div class="skeleton-row {{skeletonAlignment}}" *ngFor="let row of rows">&nbsp;</div>
        </div>
        <div class="skeleton-body-footer"*ngIf="skeletonFooter">
            <span class="skeleton-row" style="width:30%;"></span>
        </div>
    </div>
</div>
<div class="skeleton-container" [ngClass]="skeletonSize" *ngIf="skeletonType === 'image'">
    <div class="skeleton-image"></div>
</div>

<!--  
    ## How to Use Loader ##
    --Add loader component <app-pol-loader> to where you will like to use the animation.
    --Add loader properties as needed, some properties have default values and does not require you to add them unless you want to specify values
        skeletonSize: string (Default = medium)
        [skeletonType]: string (Default = text)
        [skeletonRows]: number (Default = 3)
        [skeletonTitle]: boolean (Default = false) (Optional)
        [skeletonFooter]: boolean (Default = false) (Optional)

    -- SAMPLE Use: <app-pol-loader 
                    skeletonSize="large" 
                    [skeletonType]="'text'"  *for 'image' skeleton row, title, and footer are not required and not in use.
                    [skeletonRows]="3" 
                    [skeletonTitle]="true" 
                    [skeletonFooter]="false"
                ></app-pol-loader>

    ## Future Add-on
    --Properties:
        *@Input Loader color or theme (seasonal) colors 
        *@Input Row weight or Height 
-->